import HandicappedIcon from './component'

export default HandicappedIcon
